import React from "react";
import SearchItems from "../Common/SearchItems";

const Recipes = () => {
  return <SearchItems term="filter" filter="c" id="beef" name="Meal" />;
};

export default Recipes;
